import React from 'react'
import { Box, Paper } from '@mui/material'

import { ContainerOrderItemInfo, ContainerOrderItemMedia } from '~/src/components/molecules'

import { formatMoney } from '~/src/utils/formatMoney'

type TContainerOrderItem = {
  name: string
  images: string[]
  refNo?: string
  price: number
  maker: string
  carName: string
  modelCode: string
}

interface IContainerOrderItemProps {
  data: TContainerOrderItem
}

/**
 * ContainerOrderItem
 *
 * @param __namedParameters IContainerOrderItemProps
 * @returns JSX.Element
 * @category ReactComponents
 */
export const ContainerOrderItem: React.FC<IContainerOrderItemProps> = ({ data }): JSX.Element => {
  return (
    <Paper>
      <Box padding={3}>
        <Box display={'flex'}>
          <ContainerOrderItemMedia data={data} />
          <ContainerOrderItemInfo data={data} />
        </Box>
      </Box>
    </Paper>
  )
}
